import { InputProps } from '@heroui/react';

export const inputProps : InputProps = {
  size: 'lg',
  radius: 'sm',
  variant: 'bordered',
  labelPlacement: 'outside',
};
